import _ from '../Trans';
import React, {useEffect, useState} from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Currency from './Currency'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faPlus, faCommentsDollar, faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import token from "../AuthToken";
import ReactGA from "react-ga4";
import BarLoader from "react-spinners/BarLoader";
import Config from "../Config";

function AuctionPlayerModal({showAuctionModal, modalData=null, showValueToggleHandler, auctionPlayerHandler, sellPlayerHandler}) {
    const closed = () => showValueToggleHandler(!showAuctionModal);

    return (
        <Modal isOpen={showAuctionModal} toggle={closed} onClosed={closed} id="auction-modal" tabIndex="-1" role="dialog"
               fade={false} style={{color: 'black'}}>
            <ModalHeader>
                <div className="d-flex justify-content-between w-100">
                    <div id="exampleModalLabel">{modalData?.name}</div>
                    <div className="float-right mt-1">
                        <button onClick={closed} type="button"
                                className="close float-right text-right"
                                data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="mb-2">
                <div className="d-flex justify-content-between mt-4 w-100">
                    <div className={"text-center link w-50"}>
                        <div onClick={sellPlayerHandler} data-player={modalData?.playerData?.id} data-position={modalData?.position_id}>
                        <FontAwesomeIcon icon={faMoneyBill} className="stats-modal-icon-size"/><br/>
                        <span style={{fontSize: '0.8rem'}}>{_('Sell to market')}</span><br/>
                            <small style={{fontSize: '0.6em'}}>{_('Player will be sold at the current market price')}</small>
                        </div>
                    </div>
                    <div className={"text-center link w-50"}>
                        <div onClick={auctionPlayerHandler} data-player={modalData?.playerData?.id}>
                        <FontAwesomeIcon icon={faCommentsDollar} className="stats-modal-icon-size"/><br/>
                        <span style={{fontSize: '0.8rem'}}>{_('Auction player')}</span><br/>
                            <small style={{fontSize: '0.6em'}} dangerouslySetInnerHTML={{__html: _('Player will enter auction list.<br/>If there are no bids, the player will remain in the team')}}/>
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                  <button type="button" className="btn btn-secondary pt-3 pb-3" data-dismiss="modal" onClick={closed}>
                      {_('Close')}
                  </button>
            </ModalFooter>
        </Modal>
    )
}


export default function BidModal({showBidModal, modalData=null, showValueToggleHandler, bidForPlayer}) {
    const closed = () => showValueToggleHandler(!showBidModal);

    let styleTd = {'fontSize': '1.1rem'}
    let stylePaddingRight = {'paddingRight': '15px', 'fontSize': '1.1rem'}
    const iconsWidth = modalData?.infoLink?.includes("asobal") ? "33%" : "50%";
    const [bids, setBids] = useState("");
    let [loading, setLoading] = useState(true);

    const minimumBid = modalData?.price ?? 5000 + 5000;

    useEffect(() => {
        if(showBidModal)
            fetchBids();
    }, [showBidModal]);

    const fetchBids = async() => {
        setLoading(true);
        if(modalData.playerId === undefined) {
            return;
        }
        await fetch(
                Config.bidForPlayerUrl + '?player='+modalData.playerId, {
                headers: {
                    Authorization: 'Token '+token,
                    'Content-Type': 'application/json'
                }
            })
            .then((res) => res.json())
            .then((d) =>
                d.results.map((e) => {
                    return '<tr>\n' +
                        '   <td>\n' + e.date.replace("T", " ").replace(/\..*/, "") + '</td>\n' +
                        '   <td>\n' + e.squad_name + '</td>\n' +
                        '   <td style="text-align: right">'+e.amount +' €</td>\n' +
                        '</tr>'
                }
            ))
            .then((r) => r.join(" "))
            .then((formatted) => setBids(formatted))
            .then(() => setLoading(false)).catch(() => setLoading(false))
        try {
            ReactGA.event({
                action: "search",
                category: 'search',
                label: 'submit'
            })
        } catch(e) {
            console.error(e);
            //todo: window.location.href = window.location;
        }
    }

    return (
        <Modal isOpen={showBidModal} toggle={closed} onClosed={closed} id="bid-modal" tabIndex="-1" role="dialog"
               fade={false} style={{color: 'black'}}>
            <ModalHeader>
                <div className="d-flex justify-content-between w-100">
                    <div id="exampleModalLabel">{modalData?.name}</div>
                    <div className="float-right mt-1">
                        <button onClick={closed} type="button"
                                className="close float-right text-right"
                                data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="mb-2">
                <table className='w-100'>
                    <tbody>
                        <tr>
                            <td style={styleTd}>{_('Current price')}</td><td align='right' style={stylePaddingRight}> <Currency value={modalData?.price}/> </td>
                        </tr>
                    </tbody>
                </table>

                <div className="d-flex justify-content-between mt-4 w-100">
                    <div className="link text-left"  style={{width: iconsWidth}}>
                        <input id="id_bid" name="bid" type="number" placeholder={_('Current bid') + ": " + (minimumBid)}/>
                    </div>
                    <div className={"text-center"}>
                        <div onClick={bidForPlayer} data-player={modalData?.player} data-position={modalData?.position_id}>
                        <FontAwesomeIcon icon={faPlus} className="stats-modal-icon-size"/><br/>
                        <span style={{fontSize: '0.8rem'}}>{_('Bid')}</span>
                        </div>
                    </div>
                </div>

                <table className={'w-100'} >
                    <thead>
                        <tr>
                            <td colSpan={3} style={stylePaddingRight}>{_('Bid history')}</td>
                        </tr>
                    </thead>

                        {loading && bids !== "" ?
                            <tbody>
                        <tr>
                            <td>
                                <div className="text-center w-100 d-flex justify-content-center mt-5"><BarLoader
                                    color="#23a6da"
                                    loading={loading}
                                    width={400}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                /></div>
                            </td>
                        </tr>
                        </tbody>
                            :
                            <tbody dangerouslySetInnerHTML={{__html: bids}}></tbody>
                        }
                </table>
            </ModalBody>
            <ModalFooter>
                  <button type="button" className="btn btn-secondary pt-3 pb-3" data-dismiss="modal" onClick={closed}>
                      {_('Close')}
                  </button>
            </ModalFooter>
        </Modal>
    )
}

export {AuctionPlayerModal};
